
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { CachedDataService } from '@services/data/cached-data.service';
import { ScreenService } from '@services/screen.service';
import { ObjectsService } from '@services/http/objects.service';
@Injectable()
export class MainNoDeviceGuard implements CanActivate {
  currentUrl: String = null;
  constructor(
    private router: Router,
    private screenService: ScreenService,
    private objectsService: ObjectsService,
    private cachedDataService: CachedDataService) {
    objectsService.updateObjects.subscribe(() => {

    });
  }

  public canActivate() {
    if (!this.cachedDataService.getExpiredDate()) {
      this.cachedDataService.clearCache();
      this.router.navigate(['/signin']);
      return false;
    }
    if (this.cachedDataService.isAuth()) {
      if (this.cachedDataService.getCurrentUser() && !this.cachedDataService.getCurrentUser().phoneNumberConfirmed) {
        this.screenService.isShowLoader = false;
        this.router.navigate(['/signup']);
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/signin']);
      return false;
    }

  }
}


// WEBPACK FOOTER //
// ./src/app/guards/main-no-device.guard.ts